import React from "react";
import "./NAValue.scss";

interface NAValueProps {
  value: string | number | null | undefined;
  className?: string;
}

const NAValue: React.FC<NAValueProps> = ({ value, className = "" }) => {
  if (value === null || value === undefined || value === "N/A") {
    return <span className={`na-value ${className}`}>N/A</span>;
  }

  return <span className={className}>{value}</span>;
};

export default NAValue;
